module.exports = __webpack_public_path__ + "img/drunk_notice.44ef57c4.png";